import {FormControl, FormGroup} from "@angular/forms";
import {RangeData, RangeForm} from "../types/line-chart-filters.types";

export const defaultRangeForm: FormGroup<RangeForm> = new FormGroup<RangeForm>({
  dateFrom: new FormControl(''),
  dateTo: new FormControl('')
})

export const defaultRangeData: RangeData = {
  dateFrom: '',
  dateTo: ''
}
